import { Table, TableColumn } from 'element-ui';

export default {
    name: 'AdminClubPaymentsSection',

    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },

    props: {
        affiliationFees: {
            type: Array,
            required: true
        },
        feePaymentType: {
            type: String,
            default: ''
        }
    },

    computed: {
        isOnlinePaymentWarning() {
            return this.feePaymentType === 'Online' && this.affiliationFees.length === 0;
        }
    },

    methods: {
        formatDate(row) {
            if (!row.paymentDate) return '';
            const d = new Date(row.paymentDate);
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = d.getFullYear();
            const hh = String(d.getHours()).padStart(2, '0');
            const min = String(d.getMinutes()).padStart(2, '0');
            return dd + '/' + mm + '/' + yyyy + ' ' + hh + ':' + min;
        },

        formatPrice(row) {
            if (row.price == null) return '';
            return '\u20AC ' + Number(row.price).toFixed(2);
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/admin/club/club-detail/sections/admin-club-payments-section/admin-club-payments-section.js